// @flow
import type { Node } from 'react';
import React from 'react';

import { scrubAPetData } from '@rover/react-lib/apis/pet.api';
import { Connect, Provider } from '@rover/react-lib/components/utils/Redux';
import { reducer as countryConfiguration } from '@rover/react-lib/redux/ducks/countryConfiguration.duck';
import {
  effects as frontendConfigurationEffects,
  reducer as frontendConfiguration,
} from '@rover/react-lib/redux/ducks/frontendConfiguration.duck';
import {
  effects as personEffects,
  reducer as personSummary,
  selectors as personSelectors,
} from '@rover/react-lib/redux/ducks/personSummary.duck';
import {
  actions as petsActions,
  effects as petsEffects,
  reducer as pets,
  selectors as petsSelectors,
} from '@rover/react-lib/redux/ducks/pets.duck';
import { camelize } from '@rover/utilities/object-utilities';

import EmergencyFormPage from './EmergencyFormPage';
import type { AppProps } from '.';

const validEmergencyContactInfo = summary => {
  const privateSummary = summary.private || {};
  const emergencyContactName = privateSummary.emergencyContactName || '';
  const emergencyContactPhoneNumber = privateSummary.emergencyContactPhoneNumber || '';

  return (
    emergencyContactName &&
    emergencyContactName.length &&
    emergencyContactPhoneNumber &&
    !!emergencyContactPhoneNumber.length
  );
};

const selector = state => ({
  pets: petsSelectors.getPets(state),
  getIsPetsLoading: petsSelectors.getIsLoading(state),
  getIsPersonSummaryLoading: personSelectors.getIsLoading(state),
  isVetComplete: petsSelectors.getPets(state).every(pet => pet.veterinaryInformation),
  isCareComplete: petsSelectors.getPets(state).every(pet => pet.careInstructions),
  isSexComplete: petsSelectors.getPets(state).every(pet => pet.gender),
  isContactComplete: validEmergencyContactInfo(personSelectors.getPersonSummary(state)),
  personSummary: personSelectors.getPersonSummary(state),
});

const effects = {
  savePet: petsEffects.savePet,
  savePersonSummaryPrivate: personEffects.savePersonSummaryPrivate,
};

const EmergencyFormContainer = ({ pets: petsProp, ...props }: AppProps): Node => (
  <Provider reducers={{ frontendConfiguration, pets, personSummary, countryConfiguration }}>
    <Connect
      selector={selector}
      effects={effects}
      onMount={[
        frontendConfigurationEffects.fetchFrontendConfiguration,
        () => petsActions.fetchPetsSuccess(camelize(petsProp, true).map(scrubAPetData)),
        personEffects.fetchPersonSummary,
      ]}
    >
      {redux => <EmergencyFormPage {...redux} {...props} />}
    </Connect>
  </Provider>
);

export default EmergencyFormContainer;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/EmergencyFormPageContainer.jsx